import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = { class: "card-header card-header-stretch" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 新建配置 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("排名奖励")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("门槛奖励")
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 名 ")
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_14 = {
  key: 0,
  class: "text-muted",
  style: {"font-size":"12px"}
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("停用")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 编辑 ")
const _hoisted_18 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vxe_input = _resolveComponent("vxe-input")!
  const _component_vxe_form_item = _resolveComponent("vxe-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_vxe_button = _resolveComponent("vxe-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_vxe_form = _resolveComponent("vxe-form")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_vxe_pager = _resolveComponent("vxe-pager")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_vxe_form, {
        data: _ctx.formData,
        onSubmit: _ctx.submitEvent
      }, {
        default: _withCtx(() => [
          _createVNode(_component_vxe_form_item, {
            field: "name",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_vxe_input, {
                modelValue: _ctx.formData.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
                placeholder: "配置名称"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "reward_type",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.reward_type,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.reward_type) = $event)),
                placeholder: "奖励类型",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "全部",
                    value: ""
                  }),
                  _createVNode(_component_el_option, {
                    label: "排名奖励",
                    value: "rank"
                  }),
                  _createVNode(_component_el_option, {
                    label: "门槛奖励",
                    value: "threshold"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "status",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.status,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.status) = $event)),
                placeholder: "状态",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "全部",
                    value: ""
                  }),
                  _createVNode(_component_el_option, {
                    label: "启用",
                    value: "active"
                  }),
                  _createVNode(_component_el_option, {
                    label: "停用",
                    value: "inactive"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_vxe_button, {
                type: "submit",
                status: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_button, {
                type: "button",
                onClick: _ctx.onReset
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_router_link, {
                to: { name: 'postcard_reward_config_new' },
                class: "btn btn-success ms-2"
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "onSubmit"])
    ]),
    _createVNode(_component_vxe_table, {
      data: _ctx.tableData,
      "row-config": { isHover: true }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vxe_column, {
          field: "id",
          title: "ID",
          width: "60"
        }),
        _createVNode(_component_vxe_column, {
          field: "name",
          title: "配置名称",
          width: "150"
        }),
        _createVNode(_component_vxe_column, {
          title: "奖励类型",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            (row.reward_type === 'rank')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "primary",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }))
              : (row.reward_type === 'threshold')
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: "success",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "条件",
          width: "150"
        }, {
          default: _withCtx(({ row }) => [
            (row.reward_type === 'rank')
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                  _createTextVNode(" 第 " + _toDisplayString(row.rank_start), 1),
                  (row.rank_end && row.rank_end !== row.rank_start)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, " - " + _toDisplayString(row.rank_end), 1))
                    : _createCommentVNode("", true),
                  _hoisted_10
                ]))
              : (row.reward_type === 'threshold')
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, " >= " + _toDisplayString(row.threshold_count) + " 张 ", 1))
                : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "最低流水倍率",
          width: "120"
        }, {
          default: _withCtx(({ row }) => [
            (row.reward_type === 'rank' && row.min_water_multiplier > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, " × " + _toDisplayString(row.min_water_multiplier), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_13, "—"))
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "奖励内容",
          width: "200"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(row.items_count) + " 个奖励项", 1),
            (row.description)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(row.description), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "sort_order",
          title: "排序",
          width: "80"
        }),
        _createVNode(_component_vxe_column, {
          title: "状态",
          width: "80"
        }, {
          default: _withCtx(({ row }) => [
            (row.status === 'active')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "success",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_tag, {
                  key: 1,
                  type: "info",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "created_at",
          title: "创建时间",
          width: "160"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.formatDate(row.created_at)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "操作",
          width: "150",
          fixed: "right"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_router_link, {
              to: {
              name: 'postcard_reward_config_edit',
              params: { id: row.id },
            },
              class: "btn btn-sm btn-primary me-1"
            }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 2
            }, 1032, ["to"]),
            _createElementVNode("button", {
              class: "btn btn-sm btn-danger",
              onClick: ($event: any) => (_ctx.onDelete(row))
            }, " 删除 ", 8, _hoisted_18)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_vxe_pager, {
      "current-page": _ctx.page.currentPage,
      "onUpdate:current-page": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.page.currentPage) = $event)),
      "page-size": _ctx.page.pageSize,
      "onUpdate:page-size": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.page.pageSize) = $event)),
      total: _ctx.page.totalResult,
      layouts: [
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total',
      ],
      onPageChange: _ctx.onPageChange
    }, null, 8, ["current-page", "page-size", "total", "onPageChange"])
  ]))
}